import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';	import { Truck, Wrench, LayoutDashboard, LogOut, User, Users as UsersIcon, Building2, Shield, ChevronDown, ClipboardList, Briefcase, ClipboardCheck, Wrench as WrenchIcon, FileText, CheckSquare, Clock, Calendar, Sunrise, Bell, DollarSign, BookOpen, BarChart3, BookCheck, PanelLeftClose, PanelLeftOpen, Settings as SettingsIcon, Package, Warehouse, RotateCcw, ClipboardCheck as ClipboardCheckIcon, ArrowUpDown, LogOut as LogOutIcon, Smartphone, CheckCircle, Plus, Tags, ShoppingCart, Book, UserCheck, ScrollText, Award, AlertTriangle, Menu, X, Target, Beaker, Landmark } from 'lucide-react';
import { useAuth } from './AuthContext';
import { getUnreadCount, getNotifications, markNotifRead, markAllNotifRead, getVerifikasiReturCount, getVerifikasiHariIniCount, getReturVerifikasiHariIniCount, getActivityNotifCount } from './api';
import AddActivity from './pages/activity/AddActivity';
import EditActivity from './pages/activity/EditActivity';
import ListActivity from './pages/activity/ListActivity';
import MyActivity from './pages/activity/MyActivity';
import LaporanActivity from './pages/activity/LaporanActivity';
import MarketingActivity from './pages/activity/MarketingActivity';
import ActivityRD from './pages/activity/ActivityRD';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import Regions from './pages/Regions';
import Spareparts from './pages/Spareparts';
import UsersPage from './pages/Users';
import Bagian from './pages/Bagian';
import HakAksesMenu from './pages/HakAksesMenu';
import Role from './pages/Role';
import Karyawan from './pages/Karyawan';
import Penugasan from './pages/Penugasan';
import PM from './pages/PM';
import CM from './pages/CM';
import MaintenanceDashboard from './pages/MaintenanceDashboard';
import KPI from './pages/KPI';
import DashboardAkuntansi from './pages/akuntansi/DashboardAkuntansi';
import SaldoAwal from './pages/akuntansi/SaldoAwal';
import JurnalUmum from './pages/akuntansi/JurnalUmum';
import NeracaAkuntansi from './pages/akuntansi/Neraca';
import LabaRugiAkuntansi from './pages/akuntansi/LabaRugi';
import BukuBesar from './pages/akuntansi/BukuBesar';
import COA from './pages/akuntansi/COA';
import Laporan from './pages/Laporan';
import LaporanKlien from './pages/LaporanKlien';
import Checklist from './pages/Checklist';
import Absensi from './pages/Absensi';
import JadwalKerja from './pages/JadwalKerja';
import PengajuanLembur from './pages/PengajuanLembur';
import Tagihan from './pages/Tagihan';
import CRM from './pages/CRM';
import LogSystem from './pages/LogSystem';
import Login from './pages/Login';
import ColorTokens from './pages/ColorTokens';
import Settings from './pages/Settings';
import JasaLayanan from './pages/JasaLayanan';
import ListCatatan from './pages/catatan/ListCatatan';
import HrisDashboard from './pages/hris/HrisDashboard';
import HrisKontrak from './pages/hris/HrisKontrak';
import HrisCuti from './pages/hris/HrisCuti';
import HrisPelanggaran from './pages/hris/HrisPelanggaran';
import HrisGaji from './pages/hris/HrisGaji';
import HrisPenggajian from './pages/hris/HrisPenggajian';
import HrisSlipGaji from './pages/hris/HrisSlipGaji';
import HrisKPI from './pages/hris/HrisKPI';
import HrisPelatihan from './pages/hris/HrisPelatihan';
import HrisPengunduranDiri from './pages/hris/HrisPengunduranDiri';
import AppVersion from './pages/AppVersion';
import Download from './pages/Download';
import DashboardInventori from './pages/inventori/DashboardInventori';
import Gudang from './pages/inventori/Gudang';
import Supplier from './pages/inventori/Supplier';
import InventoriSpareparts from './pages/inventori/Spareparts';
import Pembelian from './pages/inventori/Pembelian';
import VerifikasiPembelian from './pages/inventori/VerifikasiPembelian';
import LogVerifikasiPembelian from './pages/inventori/LogVerifikasiPembelian';
import VerifikasiReturPembelian from './pages/inventori/VerifikasiReturPembelian';
import LogVerifikasiRetur from './pages/inventori/LogVerifikasiRetur';
import ReturPembelian from './pages/inventori/ReturPembelian';
import StokOpname from './pages/inventori/StokOpname';
import PenyesuaianStok from './pages/inventori/PenyesuaianStok';
import StokKeluar from './pages/inventori/StokKeluar';
import KategoriSparepart from './pages/inventori/KategoriSparepart';
import PurchaseOrder from './pages/inventori/PurchaseOrder';
import PembayaranHutang from './pages/inventori/PembayaranHutang';
import RingkasanHutang from './pages/inventori/RingkasanHutang';
import RekapReimbursement from './pages/inventori/RekapReimbursement';
import Ticketing from './pages/Ticketing';
import { ThemeProvider, useTheme } from './ThemeContext';
import ThemeToggle from './components/ThemeToggle';
import './App.css';
import './styles/color-tokens.css';

function NavLink({ to, icon: Icon, badge, children, onClick }) {
  const location = useLocation();
  const isActive = location.pathname === to || location.pathname.startsWith(to + '/');
  return (
    <Link to={to} className={`nav-link ${isActive ? 'active' : ''}`} onClick={onClick}>
      <Icon size={20} />
      <span>{children}</span>
      {badge != null && badge > 0 && (
        <span className="verif-badge">{badge > 99 ? '99+' : badge}</span>
      )}
    </Link>
  );
}

function NavGroup({ icon: Icon, label, children, activePaths = [], defaultOpen }) {
  const location = useLocation();
  const isAnyChildActive = activePaths.some(path =>
    location.pathname === path || location.pathname.startsWith(path + '/')
  );
  const [open, setOpen] = useState(defaultOpen || isAnyChildActive);

  return (
    <div className={`nav-group ${open ? 'open' : ''}`}>
      <button className={`nav-group-toggle ${isAnyChildActive ? 'active' : ''}`} onClick={() => setOpen(!open)}>
        <div className="nav-group-label">
          <Icon size={20} />
          <span>{label}</span>
        </div>
        <ChevronDown size={16} className="nav-group-arrow" />
      </button>
      <div className="nav-group-children">
        {children}
      </div>
    </div>
  );
}

function NotificationBell() {
  const [unread, setUnread] = useState(0);
  const [notifs, setNotifs] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const fetchCount = () => {
    getUnreadCount()
      .then(r => setUnread(r.data.unread || 0))
      .catch(() => {});
  };

  const fetchNotifs = () => {
    getNotifications(10)
      .then(r => setNotifs(r.data || []))
      .catch(() => {});
  };

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (open) fetchNotifs();
  }, [open]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const markRead = async (id) => {
    await markNotifRead(id);
    setUnread(prev => Math.max(0, prev - 1));
    setNotifs(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
  };

  const markAllRead = async () => {
    await markAllNotifRead();
    setUnread(0);
    setNotifs(prev => prev.map(n => ({ ...n, is_read: true })));
  };

  return (
    <div className="notif-bell" ref={ref}>
      <button className="notif-bell-btn" onClick={() => setOpen(!open)}>
        <Bell size={18} />
        {unread > 0 && <span className="notif-badge">{unread > 99 ? '99+' : unread}</span>}
      </button>
      {open && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">
            <span className="notif-dropdown-title">Notifikasi</span>
            {unread > 0 && (
              <button className="notif-mark-all" onClick={markAllRead}>
                Tandai semua dibaca
              </button>
            )}
          </div>
          <div className="notif-dropdown-body">
            {notifs.length === 0 ? (
              <div className="notif-empty">Tidak ada notifikasi</div>
            ) : (
              notifs.map(n => (
                <Link
                  key={n.id}
                  to={n.link || '#'}
                  className={`notif-item ${n.is_read ? '' : 'notif-unread'}`}
                  onClick={() => { if (!n.is_read) markRead(n.id); setOpen(false); }}
                >
                  <div className="notif-item-title">{n.title}</div>
                  <div className="notif-item-msg">{n.message}</div>
                  <div className="notif-item-time">{n.created_at}</div>
                </Link>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function ThemedProtectedLayout() {
  const { theme } = useTheme();
  return (
    <div className={theme === 'classic' ? 'theme-classic' : ''}>
      <ProtectedLayout />
    </div>
  );
}

function ProtectedLayout() {
  const { isAuthenticated, loading, user, logout, hasMenuAccess } = useAuth();
  const [verifReturCount, setVerifReturCount] = useState(0);
  const [verifHariIniCount, setVerifHariIniCount] = useState(0);
  const [verifReturHariIniCount, setVerifReturHariIniCount] = useState(0);
  const [activityNotifCount, setActivityNotifCount] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      const saved = localStorage.getItem('layanansynexa_sidebar');
      return saved !== null ? JSON.parse(saved) : true;
    } catch {
      return true;
    }
  });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem('layanansynexa_sidebar', JSON.stringify(sidebarOpen));
    } catch {}
  }, [sidebarOpen]);

  // Poll verifikasi counts for sidebar badges
  useEffect(() => {
    const fetchCounts = () => {
      getVerifikasiReturCount().then(r => setVerifReturCount(r.data?.count || 0)).catch(() => {});
      getVerifikasiHariIniCount().then(r => setVerifHariIniCount(r.data?.count || 0)).catch(() => {});
      getReturVerifikasiHariIniCount().then(r => setVerifReturHariIniCount(r.data?.count || 0)).catch(() => {});
      getActivityNotifCount().then(r => setActivityNotifCount(r.data?.count || 0)).catch(() => {});
    };
    fetchCounts();
    const interval = setInterval(fetchCounts, 30000);
    return () => clearInterval(interval);
  }, []);

  // Keyboard shortcut: Ctrl+B / Cmd+B to toggle sidebar
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
        e.preventDefault();
        setSidebarOpen(prev => !prev);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner-lg" />
        <p>Memuat sistem...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={`app ${sidebarOpen ? '' : 'sidebar-collapsed'} ${mobileMenuOpen ? 'mobile-menu-active' : ''}`}>
      {/* Mobile overlay when menu is open */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)} />
      )}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <Link to="/" className="logo-link" style={{ textDecoration: 'none' }} onClick={() => setMobileMenuOpen(false)}>
                <h1 className="logo" style={{ margin: 0 }}>Layanan<span>Synexa</span></h1>
                <p className="subtitle" style={{ margin: 0 }}>Fleet Management System</p>
              </Link>
            </div>
            <NotificationBell />
            {/* Close button on mobile */}
            <button className="mobile-close-btn" onClick={() => setMobileMenuOpen(false)} aria-label="Tutup menu">
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="sidebar-user">
          <div className="sidebar-user-avatar" style={{
            overflow: 'hidden',
            background: user?.foto_url ? 'transparent' : 'rgba(255,255,255,0.1)',
          }}>
            {user?.foto_url ? (
              <img src={user.foto_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <User size={18} />
            )}
          </div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{user?.full_name || user?.username}</span>
            <span className="sidebar-user-role">{user?.role}</span>
          </div>
        </div>

        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)} title={sidebarOpen ? 'Ciutkan sidebar' : 'Perluas sidebar'}>
          {sidebarOpen ? <PanelLeftClose size={16} /> : <PanelLeftOpen size={16} />}
        </button>

        <nav className="nav-menu" onClick={() => setMobileMenuOpen(false)}>
          {(hasMenuAccess('dashboard') || hasMenuAccess('vehicles') || hasMenuAccess('spareparts') || hasMenuAccess('supplier') || hasMenuAccess('jasa_layanan')) && (
            <NavGroup icon={LayoutDashboard} label="Data Master" activePaths={["/", "/vehicles", "/spareparts", "/supplier", "/jasa-layanan"]}>
              {hasMenuAccess('dashboard') && <NavLink to="/" icon={LayoutDashboard}>Dashboard</NavLink>}
              {hasMenuAccess('vehicles') && <NavLink to="/vehicles" icon={Truck}>Kendaraan</NavLink>}
              {hasMenuAccess('supplier') && <NavLink to="/supplier" icon={Building2}>Supplier</NavLink>}
              {hasMenuAccess('jasa_layanan') && <NavLink to="/jasa-layanan" icon={Wrench}>Jasa Layanan</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('activity') || hasMenuAccess('catatan') || hasMenuAccess('activity_rd')) && (
            <NavGroup icon={FileText} label="Activity" activePaths={["/activity", "/activity/my", "/activity/add", "/activity/rd", "/catatan"]}>
              {hasMenuAccess('activity') && (
                <NavGroup icon={ClipboardList} label="Activity Umum" activePaths={["/activity", "/activity/my", "/activity/add"]}>
                  <NavLink to="/activity" icon={FileText} badge={activityNotifCount}>List Activity</NavLink>
                  <NavLink to="/activity/my" icon={User} badge={activityNotifCount}>My Activity</NavLink>
                  <NavLink to="/activity/add" icon={Plus}>Add Activity</NavLink>
                </NavGroup>
              )}
              {hasMenuAccess('activity_rd') && <NavLink to="/activity/rd" icon={Beaker}>Activity R&D</NavLink>}
              {hasMenuAccess('catatan') && <NavLink to="/catatan" icon={Book}>Catatan</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('crm')) && (
            <NavGroup icon={UsersIcon} label="CRM" activePaths={["/crm"]}>
              {hasMenuAccess('crm') && <NavLink to="/crm" icon={Target}>CRM</NavLink>}
            </NavGroup>
          )}

          {hasMenuAccess('inventori') && (
            <NavGroup icon={Package} label="Inventori" activePaths={[
              "/inventori", "/inventori/spareparts", "/inventori/kategori-sparepart",
              "/inventori/stok-opname", "/inventori/penyesuaian-stok", "/inventori/stok-keluar", "/inventori/gudang",
              "/inventori/purchase-order", "/inventori/pembelian", "/inventori/verifikasi-pembelian",
              "/inventori/log-verifikasi-pembelian", "/inventori/retur-pembelian", "/inventori/verifikasi-retur",
              "/inventori/log-verifikasi-retur"
            ]}>
              {hasMenuAccess('inventori') && <NavLink to="/inventori" icon={BarChart3}>Dashboard</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/spareparts" icon={Wrench}>Sparepart</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/kategori-sparepart" icon={Tags}>Kategori Sparepart</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/stok-opname" icon={ClipboardCheckIcon}>Stok Opname</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/stok-keluar" icon={LogOutIcon}>Stok Keluar</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/penyesuaian-stok" icon={ArrowUpDown}>Penyesuaian Stok</NavLink>}
              {hasMenuAccess('inventori') && <NavLink to="/inventori/gudang" icon={Warehouse}>Master Gudang</NavLink>}

              {/* Nested: Pembelian group */}
              <NavGroup icon={Truck} label="Pembelian" activePaths={[
                "/inventori/purchase-order", "/inventori/pembelian", "/inventori/verifikasi-pembelian",
                "/inventori/log-verifikasi-pembelian", "/inventori/retur-pembelian", "/inventori/verifikasi-retur",
                "/inventori/log-verifikasi-retur"
              ]}>
                {hasMenuAccess('inventori') && <NavLink to="/inventori/purchase-order" icon={ShoppingCart}>Purchase Order</NavLink>}
                {hasMenuAccess('inventori') && <NavLink to="/inventori/pembelian" icon={Truck}>Pembelian Langsung</NavLink>}
                {hasMenuAccess('inventori') && <NavLink to="/inventori/log-verifikasi-pembelian" icon={Clock} badge={verifHariIniCount}>Log Verifikasi</NavLink>}
                {hasMenuAccess('inventori') && <NavLink to="/inventori/retur-pembelian" icon={RotateCcw}>Retur Pembelian</NavLink>}
                {hasMenuAccess('inventori') && <NavLink to="/inventori/verifikasi-retur" icon={CheckCircle} badge={verifReturCount}>Verifikasi Retur</NavLink>}
                {hasMenuAccess('inventori') && <NavLink to="/inventori/log-verifikasi-retur" icon={Clock} badge={verifReturHariIniCount}>Log Verif. Retur</NavLink>}
              </NavGroup>
            </NavGroup>
          )}

          {(hasMenuAccess('ticketing') || hasMenuAccess('penugasan') || hasMenuAccess('pm') || hasMenuAccess('cm')) && (
            <NavGroup icon={ClipboardList} label="Maintenance" activePaths={["/ticketing", "/penugasan", "/pm", "/cm", "/kpi-teknisi", "/cm-dashboard", "/maintenance-dashboard", "/laporan-klien"]}>
              {(hasMenuAccess('cm') || hasMenuAccess('pm')) && <NavLink to="/maintenance-dashboard" icon={BarChart3}>Dashboard Maintenance</NavLink>}
              {hasMenuAccess('cm') && <NavLink to="/kpi-teknisi" icon={BarChart3}>KPI Teknisi</NavLink>}
              {hasMenuAccess('ticketing') && <NavLink to="/ticketing" icon={Wrench}>Ticketing</NavLink>}
              {hasMenuAccess('penugasan') && <NavLink to="/penugasan" icon={ClipboardCheck}>Penugasan</NavLink>}
              {hasMenuAccess('pm') && <NavLink to="/pm" icon={ClipboardCheck}>PM</NavLink>}
              {hasMenuAccess('cm') && <NavLink to="/cm" icon={WrenchIcon}>CM</NavLink>}
              {hasMenuAccess('laporan') && <NavLink to="/laporan-klien" icon={BarChart3}>Laporan Klien</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('tagihan') || hasMenuAccess('ringkasan_hutang') || hasMenuAccess('pembayaran_hutang')) && (
            <NavGroup icon={DollarSign} label="Tagihan & Hutang" activePaths={["/tagihan", "/ringkasan-hutang", "/pembayaran-hutang", "/rekap-reimbursement"]}>
              {hasMenuAccess('tagihan') && <NavLink to="/tagihan" icon={FileText}>Tagihan</NavLink>}
              {hasMenuAccess('ringkasan_hutang') && <NavLink to="/ringkasan-hutang" icon={BarChart3}>Ringkasan Hutang</NavLink>}
              {hasMenuAccess('pembayaran_hutang') && <NavLink to="/pembayaran-hutang" icon={DollarSign}>Bayar Hutang</NavLink>}
              {hasMenuAccess('pembayaran_hutang') && <NavLink to="/rekap-reimbursement" icon={Landmark}>Rekap Reimbursement</NavLink>}
            </NavGroup>
          )}

          {hasMenuAccess('akuntansi') && (
            <NavGroup icon={BookOpen} label="Akuntansi" activePaths={["/akuntansi", "/akuntansi/jurnal", "/akuntansi/neraca", "/akuntansi/laba-rugi", "/akuntansi/buku-besar", "/akuntansi/coa", "/akuntansi/saldo-awal"]}>
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi" icon={BookOpen}>Dashboard Akuntansi</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/saldo-awal" icon={Book}>Input Saldo Awal</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/jurnal" icon={BookOpen}>Jurnal Umum</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/neraca" icon={BarChart3}>Neraca</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/laba-rugi" icon={FileText}>Laba Rugi</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/buku-besar" icon={BookCheck}>Buku Besar</NavLink>}
              {hasMenuAccess('akuntansi') && <NavLink to="/akuntansi/coa" icon={FileText}>Chart of Accounts</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('laporan') || hasMenuAccess('checklist')) && (
            <NavGroup icon={FileText} label="Laporan & Checklist" activePaths={["/laporan", "/checklist"]}>
              {hasMenuAccess('laporan') && <NavLink to="/laporan" icon={FileText}>Laporan</NavLink>}
              {hasMenuAccess('checklist') && <NavLink to="/checklist" icon={CheckSquare}>Checklist</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('hris') || hasMenuAccess('karyawan')) && (
            <NavGroup icon={ScrollText} label="HRIS" activePaths={["/hris", "/hris/kontrak", "/hris/cuti", "/hris/pelanggaran", "/hris/gaji", "/hris/slip-gaji", "/hris/kpi", "/hris/pelatihan", "/absensi", "/jadwal-kerja", "/pengajuan-lembur", "/laporan-absensi", "/karyawan"]}>
              {hasMenuAccess('hris') && <NavLink to="/hris" icon={BarChart3}>Dashboard HRIS</NavLink>}
              {hasMenuAccess('karyawan') && <NavLink to="/karyawan" icon={Briefcase}>Data Karyawan</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/kontrak" icon={FileText}>Kontrak Karyawan</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/cuti" icon={Calendar}>Cuti & Izin</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/pelanggaran" icon={AlertTriangle}>Pelanggaran</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/gaji" icon={DollarSign}>Penggajian</NavLink>}
              {/* Menu "Slip Gaji" disembunyikan (alur penggajian kini di menu Penggajian).
                  Halaman & endpoint lama tetap ada agar data lama tidak hilang. */}
              {hasMenuAccess('hris') && <NavLink to="/hris/kpi" icon={BarChart3}>KPI</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/pelatihan" icon={Award}>Pelatihan</NavLink>}
              {hasMenuAccess('hris') && <NavLink to="/hris/pengunduran-diri" icon={LogOut}>Pengunduran Diri</NavLink>}
              {hasMenuAccess('absensi') && <NavLink to="/absensi" icon={Clock}>Absensi</NavLink>}
              {hasMenuAccess('jadwal_kerja') && <NavLink to="/jadwal-kerja" icon={Calendar}>Jadwal Kerja</NavLink>}
              {hasMenuAccess('pengajuan_lembur') && <NavLink to="/pengajuan-lembur" icon={Sunrise}>Pengajuan Lembur</NavLink>}
              {hasMenuAccess('laporan_absensi') && <NavLink to="/laporan-absensi" icon={FileText}>Laporan Absensi</NavLink>}
            </NavGroup>
          )}

          {(hasMenuAccess('users') || hasMenuAccess('bagian') || hasMenuAccess('hak_akses_menu') || hasMenuAccess('system_logs') || hasMenuAccess('master_role')) && (
            <NavGroup icon={UsersIcon} label="Manajemen User" activePaths={["/users", "/bagian", "/hak-akses-menu", "/system-logs", "/master-role"]}>
              {hasMenuAccess('master_role') && <NavLink to="/master-role" icon={UserCheck}>Master Role</NavLink>}
              {hasMenuAccess('users') && <NavLink to="/users" icon={User}>User</NavLink>}
              {hasMenuAccess('bagian') && <NavLink to="/bagian" icon={Building2}>Bagian</NavLink>}
              {hasMenuAccess('hak_akses_menu') && <NavLink to="/hak-akses-menu" icon={Shield}>Hak Akses Menu</NavLink>}
              {hasMenuAccess('system_logs') && <NavLink to="/system-logs" icon={Clock}>Log Sistem</NavLink>}
              {user?.role === 'admin' && <NavLink to="/settings" icon={SettingsIcon}>Pengaturan</NavLink>}
              {user?.role === 'admin' && <NavLink to="/app-version" icon={Smartphone}>Versi APK</NavLink>}
            </NavGroup>
          )}
        </nav>

        <div className="sidebar-footer">
          <ThemeToggle />
          <button onClick={() => { logout(); setMobileMenuOpen(false); }} className="logout-btn">
            <LogOut size={16} />
            <span>Keluar</span>
          </button>
        </div>
      </aside>
      <main className="main-content">
        <div className="mobile-top-bar">
          <button className="mobile-hamburger" onClick={() => setMobileMenuOpen(true)} aria-label="Buka menu">
            <Menu size={22} />
          </button>
          <span className="mobile-top-title">LayananSynexa</span>
        </div>
        <button className="sidebar-overlay-toggle" onClick={() => setSidebarOpen(true)} />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/vehicles" element={<ProtectedRoute menuKey="vehicles"><Vehicles /></ProtectedRoute>} />
          <Route path="/regions" element={<ProtectedRoute menuKey="regions"><Regions /></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute menuKey="activity"><ListActivity /></ProtectedRoute>} />
          <Route path="/activity/my" element={<ProtectedRoute menuKey="activity"><MyActivity /></ProtectedRoute>} />
          <Route path="/activity/add" element={<ProtectedRoute menuKey="activity"><AddActivity /></ProtectedRoute>} />
          <Route path="/activity/edit/:id" element={<ProtectedRoute menuKey="activity"><EditActivity /></ProtectedRoute>} />
          <Route path="/activity/laporan" element={<ProtectedRoute menuKey="activity"><LaporanActivity /></ProtectedRoute>} />
          <Route path="/activity/marketing" element={<ProtectedRoute menuKey="marketing_activity"><MarketingActivity /></ProtectedRoute>} />
          <Route path="/activity/rd" element={<ProtectedRoute menuKey="activity_rd"><ActivityRD /></ProtectedRoute>} />
          <Route path="/inventori" element={<ProtectedRoute menuKey="inventori"><DashboardInventori /></ProtectedRoute>} />
          <Route path="/inventori/spareparts" element={<ProtectedRoute menuKey="inventori"><InventoriSpareparts /></ProtectedRoute>} />
          <Route path="/inventori/pembelian" element={<ProtectedRoute menuKey="inventori"><Pembelian /></ProtectedRoute>} />
          <Route path="/inventori/verifikasi-pembelian" element={<ProtectedRoute menuKey="inventori"><VerifikasiPembelian /></ProtectedRoute>} />
          <Route path="/inventori/log-verifikasi-pembelian" element={<ProtectedRoute menuKey="inventori"><LogVerifikasiPembelian /></ProtectedRoute>} />
          <Route path="/inventori/verifikasi-retur" element={<ProtectedRoute menuKey="inventori"><VerifikasiReturPembelian /></ProtectedRoute>} />
          <Route path="/inventori/log-verifikasi-retur" element={<ProtectedRoute menuKey="inventori"><LogVerifikasiRetur /></ProtectedRoute>} />
          <Route path="/inventori/retur-pembelian" element={<ProtectedRoute menuKey="inventori"><ReturPembelian /></ProtectedRoute>} />
          <Route path="/inventori/stok-opname" element={<ProtectedRoute menuKey="inventori"><StokOpname /></ProtectedRoute>} />
          <Route path="/inventori/penyesuaian-stok" element={<ProtectedRoute menuKey="inventori"><PenyesuaianStok /></ProtectedRoute>} />
          <Route path="/inventori/stok-keluar" element={<ProtectedRoute menuKey="inventori"><StokKeluar /></ProtectedRoute>} />
          <Route path="/inventori/gudang" element={<ProtectedRoute menuKey="inventori"><Gudang /></ProtectedRoute>} />
          <Route path="/inventori/kategori-sparepart" element={<ProtectedRoute menuKey="inventori"><KategoriSparepart /></ProtectedRoute>} />
          <Route path="/inventori/purchase-order" element={<ProtectedRoute menuKey="inventori"><PurchaseOrder /></ProtectedRoute>} />
          <Route path="/catatan" element={<ProtectedRoute menuKey="catatan"><ListCatatan /></ProtectedRoute>} />
          <Route path="/jasa-layanan" element={<ProtectedRoute menuKey="jasa_layanan"><JasaLayanan /></ProtectedRoute>} />
          <Route path="/supplier" element={<ProtectedRoute menuKey="supplier"><Supplier /></ProtectedRoute>} />
          <Route path="/spareparts" element={<ProtectedRoute menuKey="spareparts"><Spareparts /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute menuKey="users"><UsersPage /></ProtectedRoute>} />
          <Route path="/master-role" element={<ProtectedRoute menuKey="master_role"><Role /></ProtectedRoute>} />
          <Route path="/bagian" element={<ProtectedRoute menuKey="bagian"><Bagian /></ProtectedRoute>} />
          <Route path="/hak-akses-menu" element={<ProtectedRoute menuKey="hak_akses_menu"><HakAksesMenu /></ProtectedRoute>} />
          <Route path="/system-logs" element={<ProtectedRoute menuKey="system_logs"><LogSystem /></ProtectedRoute>} />
          <Route path="/karyawan" element={<ProtectedRoute menuKey="karyawan"><Karyawan /></ProtectedRoute>} />
          <Route path="/ticketing" element={<ProtectedRoute menuKey="ticketing"><Ticketing /></ProtectedRoute>} />
          <Route path="/penugasan" element={<ProtectedRoute menuKey="penugasan"><Penugasan /></ProtectedRoute>} />
          <Route path="/pm" element={<ProtectedRoute menuKey="pm"><PM /></ProtectedRoute>} />
          <Route path="/cm" element={<ProtectedRoute menuKey="cm"><CM /></ProtectedRoute>} />
          <Route path="/cm-dashboard" element={<ProtectedRoute menuKey="cm"><MaintenanceDashboard /></ProtectedRoute>} />
            <Route path="/maintenance-dashboard" element={<ProtectedRoute menuKey="cm"><MaintenanceDashboard /></ProtectedRoute>} />
          <Route path="/kpi-teknisi" element={<ProtectedRoute menuKey="cm"><KPI /></ProtectedRoute>} />
          <Route path="/tagihan" element={<ProtectedRoute menuKey="tagihan"><Tagihan /></ProtectedRoute>} />
          <Route path="/crm" element={<ProtectedRoute menuKey="crm"><CRM /></ProtectedRoute>} />
          <Route path="/pembayaran-hutang" element={<ProtectedRoute menuKey="pembayaran_hutang"><PembayaranHutang /></ProtectedRoute>} />
          <Route path="/ringkasan-hutang" element={<ProtectedRoute menuKey="ringkasan_hutang"><RingkasanHutang /></ProtectedRoute>} />
          <Route path="/rekap-reimbursement" element={<ProtectedRoute menuKey="pembayaran_hutang"><RekapReimbursement /></ProtectedRoute>} />
          <Route path="/akuntansi" element={<ProtectedRoute menuKey="akuntansi"><DashboardAkuntansi /></ProtectedRoute>} />
          <Route path="/akuntansi/saldo-awal" element={<ProtectedRoute menuKey="akuntansi"><SaldoAwal /></ProtectedRoute>} />
          <Route path="/akuntansi/jurnal" element={<ProtectedRoute menuKey="akuntansi"><JurnalUmum /></ProtectedRoute>} />
          <Route path="/akuntansi/neraca" element={<ProtectedRoute menuKey="akuntansi"><NeracaAkuntansi /></ProtectedRoute>} />
          <Route path="/akuntansi/laba-rugi" element={<ProtectedRoute menuKey="akuntansi"><LabaRugiAkuntansi /></ProtectedRoute>} />
          <Route path="/akuntansi/buku-besar" element={<ProtectedRoute menuKey="akuntansi"><BukuBesar /></ProtectedRoute>} />
          <Route path="/akuntansi/coa" element={<ProtectedRoute menuKey="akuntansi"><COA /></ProtectedRoute>} />
          <Route path="/laporan" element={<ProtectedRoute menuKey="laporan"><Laporan /></ProtectedRoute>} />
          <Route path="/laporan-klien" element={<ProtectedRoute menuKey="laporan"><LaporanKlien /></ProtectedRoute>} />
          <Route path="/checklist" element={<ProtectedRoute menuKey="checklist"><Checklist /></ProtectedRoute>} />
          <Route path="/absensi" element={<ProtectedRoute menuKey="absensi"><Absensi /></ProtectedRoute>} />
          <Route path="/jadwal-kerja" element={<ProtectedRoute menuKey="jadwal_kerja"><JadwalKerja /></ProtectedRoute>} />
          <Route path="/pengajuan-lembur" element={<ProtectedRoute menuKey="pengajuan_lembur"><PengajuanLembur /></ProtectedRoute>} />
          <Route path="/laporan-absensi" element={<ProtectedRoute menuKey="laporan_absensi"><Laporan initialTab="absensi" /></ProtectedRoute>} />
          <Route path="/colors" element={<ColorTokens />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/app-version" element={<AppVersion />} />
          
          {/* HRIS Routes */}
          <Route path="/hris" element={<ProtectedRoute menuKey="hris"><HrisDashboard /></ProtectedRoute>} />
          <Route path="/hris/kontrak" element={<ProtectedRoute menuKey="hris"><HrisKontrak /></ProtectedRoute>} />
          <Route path="/hris/cuti" element={<ProtectedRoute menuKey="hris"><HrisCuti /></ProtectedRoute>} />
          <Route path="/hris/pelanggaran" element={<ProtectedRoute menuKey="hris"><HrisPelanggaran /></ProtectedRoute>} />
          <Route path="/hris/gaji" element={<ProtectedRoute menuKey="hris"><HrisPenggajian /></ProtectedRoute>} />
          {/* Halaman lama tetap tersedia (tidak dihapus) walau tidak lagi ditautkan dari sidebar */}
          <Route path="/hris/komponen-gaji" element={<ProtectedRoute menuKey="hris"><HrisGaji /></ProtectedRoute>} />
          <Route path="/hris/slip-gaji" element={<ProtectedRoute menuKey="hris"><HrisSlipGaji /></ProtectedRoute>} />
          <Route path="/hris/kpi" element={<ProtectedRoute menuKey="hris"><HrisKPI /></ProtectedRoute>} />
          <Route path="/hris/pelatihan" element={<ProtectedRoute menuKey="hris"><HrisPelatihan /></ProtectedRoute>} />
          <Route path="/hris/pengunduran-diri" element={<ProtectedRoute menuKey="hris"><HrisPengunduranDiri /></ProtectedRoute>} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/download" element={<Download />} />
          <Route path="/*" element={<ThemedProtectedLayout />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
